import { render, staticRenderFns } from "./product-scripts-inner.vue?vue&type=template&id=3b754a9c&"
import script from "./product-scripts-inner.vue?vue&type=script&lang=ts&"
export * from "./product-scripts-inner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports